import type {
  CSSProperties,
  DetailedHTMLProps,
  ImgHTMLAttributes,
  ReactNode,
} from 'react';

export interface ImageProps {
  /**
   * Image to display
   */
  img: ImgProps;

  /**
   * Caption to display below the image
   */
  caption?: ReactNode;

  /**
   * Class names to apply to the root element
   */
  classNames?: string;

  /**
   * Class names to apply to the figure element
   */
  figureClassNames?: string;

  /**
   * Class names to apply to the picture element
   */
  pictureClassNames?: string;

  /**
   * Test image to use for sizing
   */
  testImage?: HTMLImageElement;

  /**
   * Sets the style for the root element
   */
  style?: CSSProperties;
}

export type ImgProps = DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

/**
 * Determines if the props match ImageProps. See also, isVideo in Video.types
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isImage = (props: ImageProps | any): props is ImageProps =>
  props && 'img' in props && 'src' in props.img;
